import styled from '@emotion/styled';
import { Button, tokens } from '@hotjar/hotsauce';

export const BackLoginButton = styled(Button)`
  padding: 0;
`;

export const Subheader = styled('p')`
  ${tokens.text('body2')};
  color: ${tokens.color.text_light};
`;

export const SendEmailButton = styled(Button)`
  justify-content: center;
  flex-grow: 1;
`;

export const Content = styled('div')`
  display: flex;
  flex-direction: column;
  margin-top: ${tokens.spacer.x5};
  margin-bottom: ${tokens.spacer.x5};
`;
